var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    width: 1000,
    height: 1000,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "209068943_10895192") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #00AEFF } \n\t\t.s1 { opacity: .7;fill: #ffffff } \n\t\t.s2 { fill: none;stroke: #263238;stroke-miterlimit:10;stroke-width: 2 } \n\t\t.s3 { fill: none;stroke: #263238;stroke-miterlimit:10;stroke-width: 2;stroke-dasharray: 6.30042,6.30042 } \n\t\t.s4 { fill: #263238 } \n\t\t.s5 { fill: #ffffff } \n\t\t.s6 { fill: #ffffff;stroke: #263238;stroke-miterlimit:10;stroke-width: 2 } \n\t\t.s7 { fill: #00AEFF;stroke: #263238;stroke-miterlimit:10;stroke-width: 2 } \n\t\t.s8 { fill: #ffffff;stroke: #263238;stroke-linecap: round;stroke-linejoin: round;stroke-width: 2 } \n\t\t.s9 { fill: #00AEFF;stroke: #263238;stroke-linecap: round;stroke-linejoin: round;stroke-width: 2 } \n\t\t.s10 { opacity: 0;fill: #000000 } \n\t\t.s11 { fill: none;stroke: #263238;stroke-linecap: round;stroke-linejoin: round;stroke-width: 2 } \n\t\t.s12 { fill: #ffffff;stroke: #263238;stroke-linecap: round;stroke-linejoin: round;stroke-width: 2.2 } \n\t\t.s13 { mix-blend-mode: multiply;fill: #263238 } \n\t\t.s14 { fill: #263238;stroke: #263238;stroke-linecap: round;stroke-linejoin: round;stroke-width: 2.2 } \n\t\t.s15 { fill: #00AEFF;stroke: #263238;stroke-linecap: round;stroke-linejoin: round;stroke-width: 2.2 } \n\t\t.s16 { fill: none;stroke: #263238;stroke-linecap: round;stroke-linejoin: round } \n\t\t.s17 { fill: #263238;stroke: #263238;stroke-linecap: round;stroke-linejoin: round;stroke-width: 2 } \n\t\t.s18 { fill: #8a8a8a;stroke: #263238;stroke-miterlimit:10;stroke-width: 2 } \n\t\t.s19 { fill: none;stroke: #263238;stroke-linecap: round;stroke-linejoin: round;stroke-width: 2.2 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Background Simple"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m88.6 228.3c6.4-10.7 13.5-21.2 21.4-31.2 63.2-80.9 145.9-115.1 240.4-138.1 97.6-23.7 211.9-31.1 305.6 11.7 22 10.1 42.9 23.6 59.6 41.9 62.7 68.9 84.1 184.3 154 275.6 69.8 91.2 103.8 204.8 41.2 312.8-26.6 45.7-60.4 83.4-100.4 116.5-49.3 40.7-91.8 95.7-148.7 127.5-59.9 33.4-139.6 45-205.8 29.7-75.6-17.4-119.9-86.8-177.6-134.2-45.4-37.3-99.8-61.8-144.4-100.3-68.3-59-120-153.8-111.4-247.7 8.4-91.2 19.3-186 66.1-264.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s1",
    d: "m88.6 228.3c6.4-10.7 13.5-21.2 21.4-31.2 63.2-80.9 145.9-115.1 240.4-138.1 97.6-23.7 211.9-31.1 305.6 11.7 22 10.1 42.9 23.6 59.6 41.9 62.7 68.9 84.1 184.3 154 275.6 69.8 91.2 103.8 204.8 41.2 312.8-26.6 45.7-60.4 83.4-100.4 116.5-49.3 40.7-91.8 95.7-148.7 127.5-59.9 33.4-139.6 45-205.8 29.7-75.6-17.4-119.9-86.8-177.6-134.2-45.4-37.3-99.8-61.8-144.4-100.3-68.3-59-120-153.8-111.4-247.7 8.4-91.2 19.3-186 66.1-264.2z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Arrows"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m651.3 574.6v-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m651.3 565.3v-72.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m651.3 489.7v-3"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m651.3 474.9l-14.6 24h29.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m651.3 693.3v-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m651.3 684v-72.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m651.3 608.4v-3"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m651.3 593.6l-14.6 23.9h29.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m651.3 811.9v-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m651.3 802.6v-72.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m651.3 727v-3"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m651.3 712.3l-14.6 23.9h29.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m459.4 378.8v-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m459.4 369.5v-72.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m459.4 293.9v-3"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m459.4 279.1l-14.7 24h29.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m459.4 497.4v-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m459.4 488.1v-72.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m459.4 412.5v-3"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m459.4 397.8l-14.7 23.9h29.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m459.4 616.1v-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m459.4 606.8v-72.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m459.4 531.2v-3"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m459.4 516.5l-14.7 23.9h29.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m164.4 531.9v-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m164.4 522.6v-72.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m164.4 447v-3"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m164.4 432.3l-14.7 23.9h29.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m164.4 420.7v-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m164.4 411.4v-72.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m164.4 335.8v-3"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m164.4 321l-14.7 24h29.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m173.6 319.6h3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m182.9 319.6h72.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m258.5 319.6h3"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m273.2 319.6l-23.9-14.7v29.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m286.3 319.6h3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s3",
    d: "m295.6 319.6h72.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m371.2 319.6h3"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m386 319.6l-24-14.7v29.4z"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m631.4 402.1v2.7 13.4 35.1c-1.9-1.1-4.3-1.7-6.8-1.7-6.7 0-12 4.2-12 9.3 0 5.1 5.3 9.3 12 9.3 11.1 0 12-7.7 12-7.7v-45.1l31.8-4.5v34.4c-1.9-1.1-4.3-1.7-6.8-1.7-6.7 0-12 4.2-12 9.3 0 5.1 5.3 9.3 12 9.3 5.9 0 10.7-3.3 11.7-7.7l0.2-44.3v-13.4-2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s4",
    d: "m433.7 560c0 18-32.7 53.6-32.7 53.6 0 0-32.6-35.6-32.6-53.6 0-18.1 14.6-32.7 32.6-32.7 18.1 0 32.7 14.6 32.7 32.7zm-16 0c0-9.2-7.5-16.7-16.7-16.7-9.2 0-16.6 7.5-16.6 16.7 0 9.2 7.4 16.6 16.6 16.6 9.2 0 16.7-7.4 16.7-16.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m679.3 632.3h-79.7v-68.3h79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m679.3 632.3h-79.7v-68.3h79.7z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m679.3 596.6l-13.7-12.1-17 25-19.4-6.8-29.6 29.6h79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m632.6 581c0 5.1-4.1 9.2-9.1 9.2-5 0-9.1-4.1-9.1-9.2 0-5 4.1-9.1 9.1-9.1 5 0 9.1 4.1 9.1 9.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s5",
    d: "m703.2 640.2h-79.7v-68.3h79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m703.2 640.2h-79.7v-68.3h79.7z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m703.2 604.6l-13.6-12.2-17.1 25.1-19.4-6.9-29.6 29.6h79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m656.5 589c0 5-4 9.1-9.1 9.1-5 0-9.1-4.1-9.1-9.1 0-5 4.1-9.1 9.1-9.1 5.1 0 9.1 4.1 9.1 9.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m298.3 323.3c0 8.3-2.6 15.9-7.1 22.1-6.9 9.7-18.2 16-31 16-12.8 0-24.2-6.3-31.1-16-4.4-6.2-7.1-13.8-7.1-22.1 0-21.1 17.1-38.1 38.2-38.1 21 0 38.1 17 38.1 38.1z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m260.2 323.3c9.2 0 16.7-7.5 16.7-16.7 0-9.2-7.5-16.7-16.7-16.7-9.3 0-16.7 7.5-16.7 16.7 0 9.2 7.4 16.7 16.7 16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m291.2 345.4c-6.9 9.7-18.2 16-31 16-12.8 0-24.2-6.3-31.1-16 1.2-10.4 10.2-18.6 21-18.6h20.2c10.8 0 19.7 8.2 20.9 18.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s6",
    d: "m188.2 439.8c0-18-21.1-32.6-47.1-32.6-26 0-47 14.6-47 32.6 0 16.9 18.5 30.8 42.2 32.5l24.3 12.7-1.1-15.2c16.8-4.9 28.7-16.5 28.7-30z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m163.1 442.9h-46.5v-3.7h46.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m163.1 453.4h-46.5v-3.8h46.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m163.1 432.9h-46.5v-3.8h46.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s6",
    d: "m165 468.5c0-12.8 14.9-23.2 33.4-23.2 18.4 0 33.3 10.4 33.3 23.2 0 11.9-13.1 21.8-29.9 23l-17.2 9 0.7-10.7c-11.9-3.6-20.3-11.8-20.3-21.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m182.8 470.7h32.9v-2.7h-32.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m182.8 478.1h32.9v-2.7h-32.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m182.8 463.6h32.9v-2.7h-32.9z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Cloud"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m842.1 253c1.1-6.3 1.8-12.8 1.8-19.5 0-58.6-47.5-106.1-106.1-106.1-21.8 0-42.1 6.6-59 17.9-21.4-52-72.6-88.7-132.3-88.7-79 0-143.1 64.1-143.1 143.1 0 1.8 0.1 3.5 0.1 5.3-39 11.1-67.6 47-67.6 89.6 0 47.1 30.7 86 76.1 92.3l75.4 1h350.1c37.3 0 67.5-30.3 67.5-67.6 0-35.7-27.8-64.9-62.9-67.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s0",
    d: "m842.1 236.4c1.1-6.3 1.8-12.8 1.8-19.5 0-58.6-47.5-106.1-106.1-106.1-21.8 0-42.1 6.6-59 17.9-21.4-52-72.6-88.7-132.3-88.7-79 0-143.1 64.1-143.1 143.1 0 1.8 0.1 3.5 0.1 5.3-39 11.1-67.6 47-67.6 89.6 0 47.1 30.7 86 76.1 92.2l75.4 1h350.1c37.3 0 67.5-30.2 67.5-67.5 0-35.7-27.8-64.9-62.9-67.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m842.1 236.4c1.1-6.3 1.8-12.8 1.8-19.5 0-58.6-47.5-106.1-106.1-106.1-21.8 0-42.1 6.6-59 17.9-21.4-52-72.6-88.7-132.3-88.7-79 0-143.1 64.1-143.1 143.1 0 1.8 0.1 3.5 0.1 5.3-39 11.1-67.6 47-67.6 89.6 0 47.1 30.7 86 76.1 92.2l75.4 1h350.1c37.3 0 67.5-30.2 67.5-67.5 0-35.7-27.8-64.9-62.9-67.3z"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Password"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s4",
    d: "m625.6 231.2h-17.1c-14.1 0-25.6-11.5-25.6-25.6v-26.1c0-14.1 11.5-25.6 25.6-25.6h17.1c14.1 0 25.6 11.5 25.6 25.6v26.1c0 14.1-11.5 25.6-25.6 25.6zm-17.1-67.3c-8.6 0-15.6 7-15.6 15.6v26.1c0 8.6 7 15.6 15.6 15.6h17.1c8.6 0 15.6-7 15.6-15.6v-26.1c0-8.6-7-15.6-15.6-15.6z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m655 273.2h-75.9v-66.3h75.9z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m693.5 310.7h-152.9c-6.5 0-11.8-5.2-11.8-11.7 0-6.6 5.3-11.8 11.8-11.8h152.9c6.5 0 11.8 5.2 11.8 11.8 0 6.5-5.3 11.7-11.8 11.7z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s5",
    d: "m565.1 303.4l-2.3-1.4 1.7-2.4-2.6-1 0.9-2.3 2.3 1.2-0.3-2.8h3l-0.4 2.8 2.4-1.2 0.9 2.3-2.6 1 1.7 2.4-2.3 1.4-1.2-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s5",
    d: "m575.2 303.4l-2.3-1.4 1.8-2.4-2.6-1 0.9-2.3 2.3 1.2-0.3-2.8h2.9l-0.3 2.8 2.3-1.2 0.9 2.3-2.6 1 1.8 2.4-2.4 1.4-1.2-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s5",
    d: "m585.4 303.4l-2.3-1.4 1.7-2.4-2.6-1 0.9-2.3 2.3 1.2-0.3-2.8h3l-0.4 2.8 2.4-1.2 0.9 2.3-2.6 1 1.7 2.4-2.3 1.4-1.2-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s5",
    d: "m595.5 303.4l-2.3-1.4 1.8-2.4-2.6-1 0.9-2.3 2.3 1.2-0.3-2.8h2.9l-0.3 2.8 2.3-1.2 0.9 2.3-2.6 1 1.8 2.4-2.4 1.4-1.2-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s5",
    d: "m605.7 303.4l-2.3-1.4 1.7-2.4-2.5-1 0.8-2.3 2.3 1.2-0.3-2.8h3l-0.4 2.8 2.4-1.2 0.9 2.3-2.6 1 1.7 2.4-2.3 1.4-1.2-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s5",
    d: "m615.8 303.4l-2.3-1.4 1.8-2.4-2.6-1 0.9-2.3 2.3 1.2-0.3-2.8h2.9l-0.3 2.8 2.4-1.2 0.8 2.3-2.6 1 1.8 2.4-2.4 1.4-1.2-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s5",
    d: "m626 303.4l-2.3-1.4 1.7-2.4-2.5-1 0.8-2.3 2.3 1.2-0.3-2.8h3l-0.4 2.8 2.4-1.2 0.9 2.3-2.6 1 1.7 2.4-2.3 1.4-1.2-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s5",
    d: "m636.1 303.4l-2.3-1.4 1.8-2.4-2.6-1 0.9-2.3 2.3 1.2-0.3-2.8h2.9l-0.3 2.8 2.4-1.2 0.8 2.3-2.6 1 1.8 2.4-2.3 1.4-1.2-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s5",
    d: "m646.3 303.4l-2.3-1.4 1.7-2.4-2.5-1 0.8-2.3 2.3 1.2-0.3-2.8h3l-0.3 2.8 2.3-1.2 0.9 2.3-2.6 1 1.7 2.4-2.3 1.4-1.2-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s5",
    d: "m656.4 303.4l-2.2-1.4 1.7-2.4-2.6-1 0.9-2.3 2.3 1.2-0.3-2.8h2.9l-0.3 2.8 2.4-1.2 0.8 2.3-2.6 1 1.8 2.4-2.3 1.4-1.2-2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    className: "s5",
    d: "m666.6 303.4l-2.3-1.4 1.7-2.4-2.5-1 0.8-2.3 2.4 1.2-0.4-2.8h3l-0.3 2.8 2.3-1.2 0.9 2.3-2.6 1 1.7 2.4-2.3 1.4-1.2-2.6z"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m816.8 845.8c0 0 20.2-28.3 36.3-17.2 16.2 11.2 3.1 26.3-11.1 30.4-14.1 4-25.2-2.1-25.2-2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m785.4 818.5c0 0-18.2-75.8 20.2-85.9 38.4-10.1 40.5 33.4 31.4 51.6-9.1 18.2-39.5 42.4-39.5 42.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m776.3 832.7c0 0-11.1-34.4-32.3-27.3-21.2 7.1-13.2 24.2 6 36.4 19.2 12.1 28.3 12.1 28.3 12.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s7",
    d: "m780.4 895.3c0 0-19.2-23.2-13.2-52.5 6.1-29.3 36.4-33.4 50.6-13.2 14.1 20.3-11.2 65.7-11.2 65.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m771.9 882.1h-7.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m767.8 871.3l-3.6 0.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m766.8 859.5l-7.7 2.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m765.3 852.8h-5.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m753.5 845.7l-3.1 4.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m745.8 839.5l-4.1 6.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m738.6 833.3l-4.6 5.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m734 827.2l-7.2 2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m730.9 820h-6.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m732.4 811.8l-4.1-4.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m741.2 806.7l-5.2-6.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m748.8 804.6l-1.5-6.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m758.6 806.2l0.5-4.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m764.8 810.8l3-4.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m770.9 819l3.6-6.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m780.1 821.5l-3.6-5.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m783.2 812.3l-4.6-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m781.7 801.5l-6.7-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m781.7 792.8l-7.7-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m781.2 780l-6.7-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m780.7 768.2l-5.2 0.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m782.7 759.5l-4.1-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m784.8 751.3l-4.7-2.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m789.4 743.1l-5.2-3.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m795.5 736.4l-2-3.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m805.6 732.6l-1.9-4.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m817.6 730.7l1.5-6.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m831.4 735.4l2.1-6.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m837.6 744.6l6.7-3.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m841.7 755.4h5.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m842.2 767.7h6.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m839.6 778.5l3.6 2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m836.1 787.7l4.1 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m829.4 796.9l4.1 2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m822.2 804.6l5.6 3.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m817.1 810.3l4.6 5.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m806.8 818h7.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m816 825.6l3.6-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m821.7 834.4l3.1-3.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m833 829.8l-1.1-6.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m840.7 825.6v-5.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m850.4 827.2l2.1-5.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m859.1 832.8l7.2-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m861.2 843.1l5.1 1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m857.6 849.8l8.2 4.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m852 854.9l3.5 4.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m842 859l2.3 5.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m832.5 861l-0.6 4.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m824.8 859l-1.6 7.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m818.1 869.8l7.2 0.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m815.5 876.4l5.2 2.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m813.5 883.6l3.1 1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m779.6 842.3c0-1.3-1-2.3-2.3-2.3-1.3 0-2.3 1-2.3 2.3 0 1.3 1 2.3 2.3 2.3 1.3 0 2.3-1 2.3-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m762.4 829.5c0-1.3-1-2.3-2.3-2.3-1.2 0-2.3 1-2.3 2.3 0 1.3 1.1 2.3 2.3 2.3 1.3 0 2.3-1 2.3-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m751.2 829.8c0-1.3-1.1-2.4-2.4-2.4-1.2 0-2.3 1.1-2.3 2.4 0 1.2 1.1 2.3 2.3 2.3 1.3 0 2.4-1.1 2.4-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m761.4 818.5c0-1.3-1-2.3-2.3-2.3-1.3 0-2.3 1-2.3 2.3 0 1.2 1 2.3 2.3 2.3 1.3 0 2.3-1.1 2.3-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m745.5 818.5c0-1.3-1-2.3-2.3-2.3-1.3 0-2.3 1-2.3 2.3 0 1.2 1 2.3 2.3 2.3 1.3 0 2.3-1.1 2.3-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m794.8 834.4c0-1.3-1.1-2.3-2.3-2.3-1.3 0-2.4 1-2.4 2.3 0 1.2 1.1 2.3 2.4 2.3 1.2 0 2.3-1.1 2.3-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m785 831.5c0-1.2-1-2.3-2.3-2.3-1.3 0-2.3 1.1-2.3 2.3 0 1.3 1 2.4 2.3 2.4 1.3 0 2.3-1.1 2.3-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m812.2 834.9c0-1.3-1-2.3-2.3-2.3-1.3 0-2.3 1-2.3 2.3 0 1.3 1 2.3 2.3 2.3 1.3 0 2.3-1 2.3-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m818.9 841.5c0-1.2-1.1-2.3-2.3-2.3-1.3 0-2.3 1.1-2.3 2.3 0 1.3 1 2.4 2.3 2.4 1.2 0 2.3-1.1 2.3-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m833 849.8c0-1.3-1.1-2.4-2.3-2.4-1.3 0-2.3 1.1-2.3 2.4 0 1.2 1 2.3 2.3 2.3 1.2 0 2.3-1.1 2.3-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m837.3 841.8c0-1.3-1-2.3-2.3-2.3-1.2 0-2.3 1-2.3 2.3 0 1.3 1.1 2.3 2.3 2.3 1.3 0 2.3-1 2.3-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m848.6 837.4c0-1.2-1-2.3-2.3-2.3-1.3 0-2.3 1.1-2.3 2.3 0 1.3 1 2.4 2.3 2.4 1.3 0 2.3-1.1 2.3-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m849.1 848.5c0-1.3-1-2.3-2.3-2.3-1.3 0-2.3 1-2.3 2.3 0 1.2 1 2.3 2.3 2.3 1.3 0 2.3-1.1 2.3-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m797.3 808.7c0-1.3-1-2.3-2.3-2.3-1.3 0-2.3 1-2.3 2.3 0 1.3 1 2.3 2.3 2.3 1.3 0 2.3-1 2.3-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m813.7 801.8c0-1.3-1-2.3-2.3-2.3-1.2 0-2.3 1-2.3 2.3 0 1.3 1.1 2.3 2.3 2.3 1.3 0 2.3-1 2.3-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m803 792.3c0-1.3-1.1-2.3-2.3-2.3-1.3 0-2.3 1-2.3 2.3 0 1.3 1 2.3 2.3 2.3 1.2 0 2.3-1 2.3-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m789.6 791.3c0-1.3-1-2.3-2.3-2.3-1.3 0-2.3 1-2.3 2.3 0 1.3 1 2.3 2.3 2.3 1.3 0 2.3-1 2.3-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m825.8 792.8c0-1.3-1-2.3-2.3-2.3-1.3 0-2.3 1-2.3 2.3 0 1.3 1 2.3 2.3 2.3 1.3 0 2.3-1 2.3-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m815.5 784.1c0-1.3-1-2.3-2.3-2.3-1.2 0-2.3 1-2.3 2.3 0 1.3 1.1 2.3 2.3 2.3 1.3 0 2.3-1 2.3-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m807.1 767.7c0-1.3-1.1-2.3-2.3-2.3-1.3 0-2.3 1-2.3 2.3 0 1.3 1 2.3 2.3 2.3 1.2 0 2.3-1 2.3-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m806.3 747.7c0-1.3-1-2.3-2.3-2.3-1.3 0-2.3 1-2.3 2.3 0 1.3 1 2.3 2.3 2.3 1.3 0 2.3-1 2.3-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m834.3 780.5c0-1.3-1.1-2.3-2.4-2.3-1.2 0-2.3 1-2.3 2.3 0 1.3 1.1 2.3 2.3 2.3 1.3 0 2.4-1 2.4-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m825.5 768.7c0-1.3-1-2.3-2.3-2.3-1.2 0-2.3 1-2.3 2.3 0 1.3 1.1 2.3 2.3 2.3 1.3 0 2.3-1 2.3-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m828.1 744.1c0-1.3-1-2.3-2.3-2.3-1.3 0-2.3 1-2.3 2.3 0 1.3 1 2.3 2.3 2.3 1.3 0 2.3-1 2.3-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m819.4 754.3c0-1.2-1.1-2.3-2.3-2.3-1.3 0-2.3 1.1-2.3 2.3 0 1.3 1 2.4 2.3 2.4 1.2 0 2.3-1.1 2.3-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m833.5 761c0-1.3-1-2.3-2.3-2.3-1.3 0-2.3 1-2.3 2.3 0 1.3 1 2.3 2.3 2.3 1.3 0 2.3-1 2.3-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m797.1 776.4c0-1.3-1.1-2.3-2.3-2.3-1.3 0-2.3 1-2.3 2.3 0 1.3 1 2.3 2.3 2.3 1.2 0 2.3-1 2.3-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m796 756.9c0-1.3-1-2.3-2.3-2.3-1.2 0-2.3 1-2.3 2.3 0 1.3 1.1 2.3 2.3 2.3 1.3 0 2.3-1 2.3-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m790.7 851.3c0-1.3-1.1-2.3-2.4-2.3-1.2 0-2.3 1-2.3 2.3 0 1.3 1.1 2.3 2.3 2.3 1.3 0 2.4-1 2.4-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m801.7 824.1c0-1.3-1-2.3-2.3-2.3-1.3 0-2.3 1-2.3 2.3 0 1.3 1 2.3 2.3 2.3 1.3 0 2.3-1 2.3-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m806.6 842.8c0-1.2-1.1-2.3-2.4-2.3-1.2 0-2.3 1.1-2.3 2.3 0 1.3 1.1 2.3 2.3 2.3 1.3 0 2.4-1 2.4-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m763.5 841.3c0-1.3-1.1-2.3-2.3-2.3-1.3 0-2.3 1-2.3 2.3 0 1.3 1 2.3 2.3 2.3 1.2 0 2.3-1 2.3-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m776.8 854.9c0-1.3-1-2.3-2.3-2.3-1.3 0-2.3 1-2.3 2.3 0 1.3 1 2.3 2.3 2.3 1.3 0 2.3-1 2.3-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m801.9 860c0-1.3-1-2.3-2.3-2.3-1.2 0-2.3 1-2.3 2.3 0 1.3 1.1 2.3 2.3 2.3 1.3 0 2.3-1 2.3-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m776.3 869.8c0-1.3-1-2.3-2.3-2.3-1.3 0-2.3 1-2.3 2.3 0 1.2 1 2.3 2.3 2.3 1.3 0 2.3-1.1 2.3-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m797.8 876.4c0-1.2-1-2.3-2.3-2.3-1.2 0-2.3 1.1-2.3 2.3 0 1.3 1.1 2.3 2.3 2.3 1.3 0 2.3-1 2.3-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m813.7 856.9c0-1.2-1-2.3-2.3-2.3-1.2 0-2.3 1.1-2.3 2.3 0 1.3 1.1 2.3 2.3 2.3 1.3 0 2.3-1 2.3-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m810.4 870.3c0-1.3-1-2.3-2.3-2.3-1.3 0-2.3 1-2.3 2.3 0 1.2 1 2.3 2.3 2.3 1.3 0 2.3-1.1 2.3-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s4",
    d: "m787.1 867.2c0-1.3-1.1-2.3-2.3-2.3-1.3 0-2.4 1-2.4 2.3 0 1.3 1.1 2.3 2.4 2.3 1.2 0 2.3-1 2.3-2.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m744.3 876.6l9.3 69.5c0.3 6.3 5.4 11.3 11.7 11.3h51c6.3 0 11.5-5 11.7-11.3l11.8-68.7z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m750.6 921.7l15.1-22.4 26.8 25.1 24.2-26 15.5 23.8"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Device 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m199.9 765.7h-115.7v-214.5h115.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m199.9 567v-15.8h-115.7v15.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m185.4 561.8c0-1.1-0.9-2-2-2-1.1 0-2 0.9-2 2 0 1.1 0.9 2 2 2 1.1 0 2-0.9 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m190.8 561.8c0-1.1-0.9-2-2-2-1.1 0-2 0.9-2 2 0 1.1 0.9 2 2 2 1.1 0 2-0.9 2-2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s8",
    d: "m196.2 561.8c0-1.1-0.9-2-2-2-1.1 0-2 0.9-2 2 0 1.1 0.9 2 2 2 1.1 0 2-0.9 2-2z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m84.2 748.8v16.9h115.7v-16.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m164.7 551.2l-80.5 140.6v50.2l109.4-190.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s10",
    d: "m199.9 639l-1.9-1.3-69.6 123 1.9 5h69.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Compound Path>",
    fillRule: "evenodd",
    className: "s4",
    d: "m203.1 593.4v3.2q0.2 0 0.3 0c0.8 0 1.4 0.6 1.4 1.4v14.3c0 0.8-0.6 1.4-1.4 1.4q-0.1 0-0.3 0v3.2q0.2 0 0.3 0c0.8 0 1.4 0.6 1.4 1.4v14.3c0 0.8-0.6 1.5-1.4 1.5q-0.1 0-0.3-0.1v131.4c0 5.1-4.1 9.2-9.2 9.2h-101.6c-5.1 0-9.2-4.1-9.2-9.2v-215.9c0-5.1 4.1-9.2 9.2-9.2h101.6c5.1 0 9.2 4.1 9.2 9.2v26.8q0.2-0.1 0.3-0.1c0.8 0 1.4 0.7 1.4 1.5v14.3c0 0.7-0.6 1.4-1.4 1.4q-0.1 0-0.3 0zm-5.3-37.2h-109.4v204.5h109.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m120.1 607.2h-15.5c-2.8 0-5-2.3-5-5v-12.4c0-2.8 2.2-5 5-5h15.5c2.7 0 5 2.2 5 5v12.4c0 2.7-2.3 5-5 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m151.7 607.2h-15.5c-2.7 0-5-2.3-5-5v-12.4c0-2.8 2.3-5 5-5h15.5c2.8 0 5 2.2 5 5v12.4c0 2.7-2.2 5-5 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m183.3 607.2h-15.5c-2.7 0-4.9-2.3-4.9-5v-12.4c0-2.8 2.2-5 4.9-5h15.5c2.8 0 5 2.2 5 5v12.4c0 2.7-2.2 5-5 5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m120.1 644.6h-15.5c-2.8 0-5-2.2-5-5v-12.4c0-2.7 2.2-5 5-5h15.5c2.7 0 5 2.3 5 5v12.4c0 2.8-2.3 5-5 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m151.7 644.6h-15.5c-2.7 0-5-2.2-5-5v-12.4c0-2.7 2.3-5 5-5h15.5c2.8 0 5 2.3 5 5v12.4c0 2.8-2.2 5-5 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m183.3 644.6h-15.5c-2.7 0-4.9-2.2-4.9-5v-12.4c0-2.7 2.2-5 4.9-5h15.5c2.8 0 5 2.3 5 5v12.4c0 2.8-2.2 5-5 5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m120.1 682h-15.5c-2.8 0-5-2.2-5-4.9v-12.4c0-2.8 2.2-5 5-5h15.5c2.7 0 5 2.2 5 5v12.4c0 2.7-2.3 4.9-5 4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m151.7 682h-15.5c-2.7 0-5-2.2-5-4.9v-12.4c0-2.8 2.3-5 5-5h15.5c2.8 0 5 2.2 5 5v12.4c0 2.7-2.2 4.9-5 4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m183.3 682h-15.5c-2.7 0-4.9-2.2-4.9-4.9v-12.4c0-2.8 2.2-5 4.9-5h15.5c2.8 0 5 2.2 5 5v12.4c0 2.7-2.2 4.9-5 4.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m120.1 719.5h-15.5c-2.8 0-5-2.2-5-5v-12.4c0-2.8 2.2-5 5-5h15.5c2.7 0 5 2.2 5 5v12.4c0 2.8-2.3 5-5 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m151.7 719.5h-15.5c-2.7 0-5-2.2-5-5v-12.4c0-2.8 2.3-5 5-5h15.5c2.8 0 5 2.2 5 5v12.4c0 2.8-2.2 5-5 5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s11",
    d: "m183.3 719.5h-15.5c-2.7 0-4.9-2.2-4.9-5v-12.4c0-2.8 2.2-5 4.9-5h15.5c2.8 0 5 2.2 5 5v12.4c0 2.8-2.2 5-5 5z"
  }))))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Device 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m393.5 919.1v-30.8h-90.9v30.8c0 10.1-3.4 19.9-9.6 27.8l-4 5h118.1l-4-5c-6.2-7.9-9.6-17.7-9.6-27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s13",
    d: "m396 933.9c-1.7-4.7-2.5-9.7-2.5-14.8v-30.8h-90.9v30.8c0 5.1-0.8 10.1-2.5 14.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m407.1 957.4h-118.1v-5.5h118.1z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s14",
    d: "m519.2 898h-342.3c-6.2 0-11.3-5.1-11.3-11.3v-251c0-6.3 5.1-11.4 11.3-11.4h342.3c6.2 0 11.3 5.1 11.3 11.4v251c0 6.2-5.1 11.3-11.3 11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m519.2 898h-342.3c-6.2 0-11.3-5.1-11.3-11.3v-31.2h364.9v31.2c0 6.2-5.1 11.3-11.3 11.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m512.2 834.7h-328.3v-193.4h328.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m512.2 657.9v-16.6h-328.3v16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m183.9 818.3v16.4h328.3v-16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s12",
    d: "m510.5 818.3h-265.5l7.8 16.4h257.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s15",
    d: "m511 818.3h-196.7l7.8 16.4h188.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m192.8 691.8h311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m192.8 713.6h311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m192.8 735.4h311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m192.8 757.2h311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m192.8 779.1h311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m192.8 800.9h311"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m212.4 664.5v147.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m248.4 664.5v147.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m284.4 664.5v147.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m320.5 664.5v147.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m356.5 664.5v147.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m392.5 664.5v147.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m428.5 664.5v147.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m464.5 664.5v147.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s16",
    d: "m500.5 664.5v147.3"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Device 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m743.7 957.4h-245.5l-34.3-166.1c-0.5-2.2 0.9-4 3.1-4h237.5c2.3 0 4.4 1.8 4.9 4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s18",
    d: "m746.3 957.4h-245.5l-34.4-166.1c-0.4-2.2 1-4 3.2-4h237.5c2.2 0 4.4 1.8 4.9 4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m738.4 951.1h-232.3l-32.6-157.5h232.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s6",
    d: "m512.5 951.1h-6.4l-32.6-157.5h6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s18",
    d: "m492 883l-8.5-41.3h6.4l8.6 41.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m708.2 805.1l-2.4-11.5h-232.3l2.4 11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s9",
    d: "m504.3 942.4l1.8 8.7h232.3l-1.8-8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s17",
    d: "m855.6 957.4h-357.3v-6.9h357.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s18",
    d: "m664.7 950.5v6.9h190.9v-6.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m707.4 859.6h-58.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m709.5 870.6h-58.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m711.6 881.5h-58.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m713.6 892.5h-58.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m715.7 903.4h-58.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m717.7 914.4h-58.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m628.2 826.8h-58.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m630.3 837.7h-58.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m632.4 848.7h-58.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m634.4 859.6h-58.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m636.5 870.6h-58.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m638.5 881.5h-58.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m640.6 892.5h-58.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m642.7 903.4h-58.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m644.7 914.4h-58.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m555.2 826.8h-58.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m557.3 837.7h-58.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m559.4 848.7h-58.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m561.4 859.6h-58.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m563.5 870.6h-58.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m565.5 881.5h-58.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m567.6 892.5h-58.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m569.7 903.4h-58.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s19",
    d: "m571.7 914.4h-58.4"
  })))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Table"
  }, /*#__PURE__*/React.createElement("path", {
    id: "<Path>",
    className: "s2",
    d: "m961.8 957.4h-921.2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.8e4319c4fbf6b6e7386fa1ec69b16b41.svg";
export { ForwardRef as ReactComponent };